/* eslint-disable i18next/no-literal-string */
import React from 'react';
import step1Image from 'assets/images/gen-ai-image-landing/how-it-works/1.png';
import step2Image from 'assets/images/gen-ai-image-landing/how-it-works/2.png';
import step3Image from 'assets/images/gen-ai-image-landing/how-it-works/3.png';
import styles from './HowItWorks.module.scss';

export default function HowItWorks() {
  return (
    <div className={styles.howItWorksSection}>
      <div className={styles.header}>
        <h2 className={styles.title}>HOW IT WORKS</h2>
        <p className={styles.subtitle}>
          You imagine it, and we bring it to life. From your living room to your bedroom—or
          any space you dream of—our process is designed to make transforming your
          ideas into reality simple, smooth, and enjoyable.
        </p>
      </div>

      <div className={styles.steps}>
        <div className={styles.step}>
          <div className={styles.separator} />
          <div className={styles.stepRow}>
            <div className={styles.stepImage}>
              <img src={step1Image} alt="Upload your room" />
            </div>
            <div className={styles.stepNumber}>01</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Upload your room</h3>
              <p className={styles.stepDescription}>
                Simply upload a photo of your space and let our
                tool capture every detail. Within seconds, you'll
                have a digital canvas ready for transformation.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.step}>
          <div className={styles.separator} />
          <div className={styles.stepRow}>
            <div className={styles.stepImage}>
              <img src={step2Image} alt="Choose the style you love" />
            </div>
            <div className={styles.stepNumber}>02</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Choose the style you love</h3>
              <p className={styles.stepDescription}>
                Pick your room type and explore different design
                styles – from modern to industrial, or anything in
                between. See how your space instantly adapts to
                your taste.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.step}>
          <div className={styles.separator} />
          <div className={styles.stepRow}>
            <div className={styles.stepImage}>
              <img src={step3Image} alt="And it's done" />
            </div>
            <div className={styles.stepNumber}>03</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>And it's done</h3>
              <p className={styles.stepDescription}>
                Your new design is ready to view in a realistic 3D
                experience. Enjoy a clear vision of how your
                dream space will look—simple, seamless, and
                inspiring. Refine and iterate as many times as you
                like until you're fully satisfied.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
